import { render, staticRenderFns } from "./ElePaySuccess.vue?vue&type=template&id=cd475cba"
import script from "./ElePaySuccess.vue?vue&type=script&lang=js"
export * from "./ElePaySuccess.vue?vue&type=script&lang=js"
import style0 from "./ElePaySuccess.vue?vue&type=style&index=0&id=cd475cba&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports